/**
 * 支付处理页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const payingCommonConfig = {
  texts: {
    paymentFailure: 'Payment failure',
    paymentSuccess: 'Payment success',
    rechargePleaseWait: 'Recharge please wait',
  },
}
